import React, { useState, useMemo } from 'react'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { SideContent } from 'components-shared'
import CardPreview from 'packages/ui/CardPreview'
import CardSkeleton from 'components/global/CUK/Skeletons/CardSkeleton'
import Header from './Header'
import CardBody from './CardBody.js'

export const Card = ({ device, loading, onCloseClick }) => {
  const { t } = useTranslation()
  const isParent = device?.children && device.children.length > 0

  const defaultTab = useMemo(() => (isParent ? 'group' : 'informations'), [isParent])
  const [activeTab, setActiveTab] = useState(defaultTab)

  if (loading) {
    return (
      <SideContent
        style={{
          marginTop: 0,
          height: '100%',
          width: '100%',
          borderTopRightRadius: '24px',
          borderBottomRightRadius: '24px',
          overflow: 'hidden'
        }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}>
          <CardSkeleton />
        </Box>
      </SideContent>
    )
  }

  return (
    <SideContent
      style={{
        marginTop: 0,
        height: '100%',
        width: '100%',
        borderTopRightRadius: '24px',
        borderBottomRightRadius: '24px',
        overflow: 'hidden',
        display: 'flex'
      }}>
      <CardPreview title={t('ui_elements.card_title')} onClose={onCloseClick}>
        <Box
          sx={{
            flex: '1 1 auto',
            minHeight: 0,
            width: '100%',
            overflowY: 'auto',
            overflowX: 'hidden',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            pb: 2,
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            '& *': {
              minWidth: 0
            }
          }}>
          <Header device={device} activeTab={activeTab} onTabChange={setActiveTab} />
          <CardBody device={device} activeTab={activeTab} />
        </Box>
      </CardPreview>
    </SideContent>
  )
}

export default Card
